import styles from './EmptyState.module.css';

/**
 * 아무것도 없을 때 두는 자리.
 *
 * **조용한 한 줄이다.** 예전에는 점선 테두리 안에 흐린 그림 하나를 놓았는데,
 * 빈 화면에 그 네모가 유일한 덩어리라 화면이 덜 만들어진 것처럼 보였다 —
 * 채워질 자리를 그려 둔 것이 오히려 비어 있음을 크게 말하고 있었다.
 *
 * 글로 돌아온 이유: 화면을 못 보는 사람에게 빈 칸은 아무 말도 하지 않는다.
 * 예전에는 그 말을 `srOnly`로 숨겨 뒀는데, 어차피 있어야 할 문장이면
 * 모두에게 보여주고 그림을 빼는 편이 화면도 깔끔하다.
 */
export function EmptyState({ label }: { label: string }) {
  return <p className={styles.empty}>{label}</p>;
}
